import React from "react";
import { TieredMenu } from "primereact/tieredmenu";

import Header from "@/components/shared/Header";
import Table from "@/components/shared/Table";
import EditUser from "./CreateEditUser";
import UserDetails from "@/pages/app/users/UserDetails";

import { usersFilterMenu } from "@/utils/usersFilterMenu";
import { users as data } from "@constants/dummy";
import { useResetPagination } from "@/hooks/useResetPagination";
import { userColumns } from "@/constants/columns";
import { filterUsers } from "@/utils/filters";
import Container from "@/components/shared/Container";
import ResetPassword from "./ResetPassword";

export default function ManageUsers() {
  const menu = React.useRef<TieredMenu>(null);

  const [users, setUsers] = React.useState<any>([]);
  const [filter, setFilter] = React.useState<string>("");
  const [showSearch, toggleSearch] = React.useReducer((s) => !s, false);
  const [selectedUser, setSelectedUser] = React.useState<any>({});
  const [showEdit, setShowEdit] = React.useState<boolean>(false);
  const [showView, setShowView] = React.useState<boolean>(false);
  const [showResetPassword, setShowResetPassword] =
    React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const resetPagination = useResetPagination(filter);
  const filteredUsers = filterUsers(users, filter);

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setUsers(data);
    }, 500);
  }, []);

  return (
    <div>
      <Header
        title={"User Management"}
        showSearch={showSearch}
        onDownload={() => {}}
        onFilter={(event) => menu.current?.toggle(event)}
        onSearch={toggleSearch}
        onCloseSearch={() => {
          toggleSearch();
          setFilter("");
        }}
        extraAction="Add User"
        extraActionIcon="pi pi-plus"
        onExtraAction={() => {
          setSelectedUser({});
          setShowEdit(true);
        }}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        menuComponent={
          <TieredMenu
            ref={menu}
            popup
            model={usersFilterMenu(setFilter)}
            breakpoint="767px"
          />
        }
      />

      <Container loading={loading}>
        <Table
          data={filteredUsers}
          columns={userColumns(
            setSelectedUser,
            setShowEdit,
            setShowView,
            setShowResetPassword
          )}
          resetPagination={resetPagination}
          emptyIcon="pi-users"
          emptyMessage="No users found at the moment"
        />

        <UserDetails
          show={showView}
          onHide={() => setShowView(false)}
          user={selectedUser}
          onEdit={() => {
            setShowResetPassword(false);
            setShowView(false);
            setShowEdit(true);
          }}
        />

        <EditUser
          show={showEdit}
          onHide={() => setShowEdit(false)}
          user={selectedUser}
          setShowEdit={setShowEdit}
        />

        <ResetPassword
          show={showResetPassword}
          onHide={() => setShowResetPassword(false)}
          user={selectedUser}
        />
      </Container>
    </div>
  );
}
